import React from 'react';

import s from './styles.module.scss';

interface IProgressBarProps {
  clamped: number;
  total: number;
}

export const ProgressBar = ({
  clamped = 0,
  total = 100,
}: IProgressBarProps) => {
  const percent = total > 0 ? Math.round((clamped / total) * 100) : 0;

  return (
    <div className={s['progress-wrapper']}>
      <div className={s['progress-line-wrapper']}>
        <div
          className={s['progress-line-fill']}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className={s.percent}>{percent}%</span>
    </div>
  );
};
